<template>
  <div>
    <el-table
      :data="websiteAccessLogs"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="logId"
        :label="$t('websiteAccessLogManage.logId')"
        align="center"
      />
      <el-table-column
        prop="ip"
        :label="$t('websiteAccessLogManage.ip')"
        align="center"
      />
      <el-table-column
        prop="accessTime"
        :label="$t('websiteAccessLogManage.accessTime')"
        align="center"
      />
      <el-table-column
        prop="accessUrl"
        :label="$t('websiteAccessLogManage.accessUrl')"
        align="center"
      />
      <el-table-column
        prop="loginState"
        :label="$t('websiteAccessLogManage.loginState')"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.loginState == 0 ? $t('websiteAccessLogManage.notLogin') : $t('websiteAccessLogManage.loggedIn') }}
        </template>
      </el-table-column>
      <el-table-column
        prop="loginName"
        :label="$t('websiteAccessLogManage.loginName')"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.loginName || '-' }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 20px; text-align: right;"
      @current-change="handlePageChange"
      :current-page="page"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
    />
  </div>
</template>

<script>
export default {
  name: 'WebsiteAccessLogTable',
  props: {
    websiteAccessLogs: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handlePageChange(currentPage) {
      this.$emit('page-change', currentPage, 10)
    }
  }
}
</script>